// Incidencias técnicas del centro — resumen discreto y desplegable. No compite con alarmas humanas.
import { useState } from "react";
import { ShieldAlert, ChevronDown, ChevronUp } from "lucide-react";

const toneTxt = { bad: "text-[#9B2C2C]", warn: "text-[#B45309]", muted: "text-slate-500", ok: "text-emerald-700" };

export default function CoberturasResumen({ coberturas, historicas = false }) {
  const [open, setOpen] = useState(false);
  if (!coberturas || coberturas.length === 0) return null;
  return (
    <section data-testid="centro-coberturas" className={`rounded-xl border p-3 ${historicas ? "border-slate-300 bg-slate-50" : "border-[#9B2C2C]/25 bg-[#9B2C2C]/[0.05]"}`}>
      <button data-testid="centro-coberturas-toggle" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between text-left">
        <span className={`inline-flex items-center gap-2 text-sm font-bold ${historicas ? "text-slate-600" : "text-[#9B2C2C]"}`}><ShieldAlert className="h-4 w-4" /> {coberturas.length} {coberturas.length === 1 ? "cobertura a revisar" : "coberturas a revisar"}{historicas ? " · última lectura sin confirmar" : ""}</span>
        {open ? <ChevronUp className="h-4 w-4 text-[#9B2C2C]" /> : <ChevronDown className="h-4 w-4 text-[#9B2C2C]" />}
      </button>
      {open && (
        <ul className="mt-2 space-y-1.5" data-testid="centro-coberturas-lista">
          {coberturas.map((c, i) => (
            <li key={i} className="flex items-center justify-between rounded-lg bg-white/70 px-2.5 py-1.5 text-sm">
              <span className="text-slate-700">{c.persona} · {c.capacidad}</span>
              <span data-testid={`centro-cobertura-estado-${c.estado || "otro"}`} className={`text-xs font-semibold ${toneTxt[c.tone] || toneTxt.muted}`}>{c.label}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
